export function toComputationPaymentMethod(paymentMethod) {
    if (paymentMethod)
        return {
            paymethod_token: paymentMethod.paymethod_token,
            type: paymentMethod.card ? 'card' : paymentMethod.echeck ? 'bank' : undefined,
        };
}
export function fromOwnerChargeToChargeItem(ownerCharge) {
    return {
        charge_id: ownerCharge.charge_id,
        charge_hr_id: ownerCharge.charge_hr_id,
        amount: {
            unit: 'USD',
            value: ownerCharge.amount_due,
        },
    };
}
